import { createAction, handleActions } from 'redux-actions';

const setSupplierItemForEdit = createAction("SCREENS/SUPPLIER_VIEW/SET_SUPPLIER_ITEM_FOR_EDIT");

const defaultState = null;

const reducer = handleActions(
  {
    [setSupplierItemForEdit]: (state, action) => action.payload
  },
  defaultState
);

export { setSupplierItemForEdit, reducer };
